import { Header } from "@/components/layout/Header";
import { MenuBar } from "@/components/menu/MenuBar";
import { Tabs } from "@/components/tabs/Tabs";
import { MosaicComponent } from "../../../components/mosaic/MosaicComponent";
import { useDefineUserStatus } from "../hooks/useDefineUserStatus";
import { FormRenderer } from "./components/FormRenderer";

export const DashboardPage = () => {
	const { userStatus, setUserStatus } = useDefineUserStatus();

	return (
		<div className="h-screen flex flex-col">
			<Header
				content={
					<>
						<MenuBar />
						<Tabs />
					</>
				}
			/>

			<div className="flex-1 flex min-h-0">
				<MosaicComponent />

				<FormRenderer userStatus={userStatus} setUserStatus={setUserStatus} />
			</div>
		</div>
	);
};
